import { Tag } from 'antd';
import Media from 'react-media';
import APP from 'stores/APP';
import classlist from 'utils/classlist';
import { statusConfig } from '../../helper';
import { ProcessStatusEnum } from '../../types';
import './style.scss';

interface StatusIconProps {
    status: ProcessStatusEnum | null;
    isDarkMode: boolean; // 是否是暗黑模式
    statusText?: string;
    color?: string;
    className?: string;
}

const StatusIcon: React.FC<StatusIconProps> = ({ status, statusText, color, className, isDarkMode }) => {
    const defaultStatusConfig = status ? statusConfig[status] || statusConfig[ProcessStatusEnum.PENDING] : undefined;

    return (
        <Media
            query={{
                maxWidth: 576
            }}>
            {matches => {
                const isSmScreen = APP.isTiger || matches;
                const finalStatusText = statusText || defaultStatusConfig?.statusText;
                const finalColor = color || defaultStatusConfig?.color;

                return (
                    <>
                        {isSmScreen ? (
                            <div
                                className={classlist(
                                    'status-icon-root',
                                    isDarkMode ? 'dark-mode' : 'white-mode',
                                    `status-${status}`,
                                    className
                                )}>
                                {finalStatusText}
                            </div>
                        ) : (
                            <Tag className={classlist('mr-0', className)} color={finalColor}>
                                {finalStatusText}
                            </Tag>
                        )}
                    </>
                );
            }}
        </Media>
    );
};

export default StatusIcon;
